
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Sparkle, Gauge, Thermometer } from 'lucide-react';

const EnergySavingsCard = () => {
  // Sample data based on HVAC, chillers and other systems
  const savingsData = [
    {
      system: 'HVAC Systems',
      icon: <Gauge className="h-5 w-5 text-blue-500" />,
      saving: 14.3,
      target: 20,
      color: 'bg-blue-500',
    },
    {
      system: 'Chiller Plant',
      icon: <Thermometer className="h-5 w-5 text-emerald-500" />,
      saving: 8.7,
      target: 15,
      color: 'bg-emerald-500',
    },
    {
      system: 'Lighting',
      icon: <Sparkle className="h-5 w-5 text-amber-500" />,
      saving: 23.5,
      target: 25,
      color: 'bg-amber-500',
    },
  ];

  return (
    <Card className="lg:col-span-1">
      <CardHeader>
        <CardTitle className="text-xl font-bold">Energy Savings</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {savingsData.map((item, index) => (
            <div key={index} className="space-y-2">
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-2">
                  {item.icon}
                  <span className="font-medium">{item.system}</span>
                </div>
                <span className="text-sm font-bold">
                  {item.saving}% <span className="text-gray-400 font-normal">of {item.target}%</span>
                </span>
              </div>
              <div className="relative pt-1">
                <Progress 
                  value={(item.saving / item.target) * 100} 
                  className="h-2"
                  indicatorClassName={item.color}
                />
                
                <div className="flex text-xs mt-1 justify-between">
                  <span>Current: {item.saving}%</span>
                  <span>Target: {item.target}%</span>
                </div>
              </div>
              
              <div className="text-sm text-gray-500 mt-1">
                {item.saving >= item.target * 0.8 ? (
                  <p>Great progress! Almost at target efficiency.</p>
                ) : (
                  <p>Working towards target efficiency level.</p>
                )}
              </div>
            </div>
          ))}
          
          <div className="border-t pt-4 mt-6">
            <div className="flex justify-between items-center">
              <span className="font-medium">Total Annual Savings</span>
              <span className="text-xl font-bold text-green-600">$47,320</span>
            </div>
            <p className="text-sm text-gray-500 mt-1">Based on current consumption patterns</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default EnergySavingsCard;
